import script from "./HistoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./HistoryComponent.vue?vue&type=style&index=0&id=26f0ba1f&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebase 8x8\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f0ba1f"]])

export default __exports__